export enum Events {
  NOTE_CREATE = "note created",
}
export class NoteEventTarget extends EventTarget {}

const instance = new NoteEventTarget();
export default instance;
